import React, { useEffect, useRef, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'

export default function AnimacionScroll() {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  // Animación con entrada y salida
  const estilos = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 120, friction: 20 }
  })

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Si el elemento entra en pantalla → aparece
        if (entry.isIntersecting) {
          setVisible(true)
        } else {
          // Si sale de pantalla → desaparece
          setVisible(false)
        }
      },
      { threshold: 0.8 } // Se activa cuando el 100% del elemento es visible
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  return (
    <div style={{ textAlign: 'left', marginTop: '0px' }}>
      <animated.h2 ref={ref} style={estilos}>
        <span
          style={{
            leading: 'relaxed',
            fontSize: '18px',
            fontWeight: '400',
            color: '#94a3b8',
            fontFamily: "Space Grotesk, sans-serif"
          }}>Nuestra IA elimina muebles antiguos o distracciones, entregando un espacio limpio y moderno para que el cliente proyecte su futuro.
        </span>
      </animated.h2>
    </div>
  )
}


